interface IGetActualsAndPlansYearsQuarters {
  fYear: number
  fQuarter: number
}

const actualQuarters = {
  2: 'Q1',
  3: 'Q1, Q2',
  4: 'Q1, Q2, Q3',
}

const plannedQuarters = {
  1: 'Q1, Q2, Q3, Q4',
  2: 'Q2, Q3, Q4',
  3: 'Q3, Q4',
  4: 'Q4',
}
export const getActualsAndPlansYearsQuarters = ({
  fYear,
  fQuarter,
}: IGetActualsAndPlansYearsQuarters) => {
  if (fQuarter > 1) {
    return {
      prevFYear: fYear - 1,
      currentYearActuals: `${fYear} ${actualQuarters[fQuarter]}`,
      currentYearPlans: `${fYear} ${plannedQuarters[fQuarter]}`,
    }
  }

  return {
    prevFYear: fYear - 1,
    currentYearPlans: `${fYear} ${plannedQuarters[fQuarter]}`,
  }
}
